import { AI_API_URL } from '../../../constants';
import { useYouTubeAPI } from './useYouTubeAPI';

export const useHistoryCopier = () => {
  const { fetchVideoTitle } = useYouTubeAPI();

  // 광역 히스토리에서 개인 히스토리로 복사
  const copyFromGlobalHistory = async (extractedVideoId, language, userId, setInputUrl, setInputTitle) => {
    try {
      // YouTube API로 영상 제목 가져오기 (모달에 표시할 용도)
      const videoTitle = await fetchVideoTitle(extractedVideoId);
      
      // 광역 히스토리에서 개인 히스토리로 복사
      const copyResponse = await fetch(`${AI_API_URL}/api/streaming/copy-from-global-history/${extractedVideoId}?language=${language}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'user-id': userId
        }
      });
      
      if (copyResponse.ok) {
        const copyResult = await copyResponse.json();
        console.log(`🎉 [광역→개인 복사] 성공! 새 히스토리 ID: ${copyResult.historyId}`);
        
        // 입력 필드 초기화
        setInputUrl("");
        setInputTitle("");
        
        // 복사된 히스토리로 이동 (모달은 페이지에서 처리)
        return { 
          historyId: copyResult.historyId, 
          copiedFromGlobal: true,
          videoTitle: videoTitle
        };
      } else {
        const errorText = await copyResponse.text();
        console.error(`❌ [광역→개인 복사] 실패:`, copyResponse.status, errorText);
        return null;
      }
    } catch (error) {
      console.error(`❌ [광역→개인 복사] 에러:`, error);
      return null;
    }
  };

  return {
    copyFromGlobalHistory
  };
}; 